<div class="table-header carta">
  <div *ngIf="entries.length">
    <app-membrated-letter
      module="C"
      [batchId]="this.bacthId"
    ></app-membrated-letter>
  </div>
</div>
<app-table
  [table_config]="table_config"
  [array]="entries"
  [loader]="loader"
  (onEliminarSalida)="downloadFile($event)"
  (onEliminarEntryExport)="confirm($event)"
  (onExportEntryDetail)="mostrarEntrada($event, 'detalle')"
  (onExportEntryUpdate)="mostrarEntrada($event, 'actualizar')"
></app-table>
<app-overlay
  *ngIf="entryEliminar"
  [buttons]="true"
  mensaje="¿Estás seguro de eliminar la entrada {{ currentEntryId }}?"
  (onDeleteLote)="deleteSalida($event)"
></app-overlay>
<div class="overlay-detalle" *ngIf="overlay">
  <div class="detalle-salida">
    <div class="table-header">
      <h2 class="title">
        <span (click)="closeDetalle()">
          <app-arrow-back></app-arrow-back>
        </span>
        {{ subtitulo }}
      </h2>
    </div>
    <app-cabotage-entry-transport
      [containerStyles]="containerStyles"
      [entriesType]="entriesType"
      [entryDetalle]="entryDetalle"
      [movimiento]="movimiento"
      [archivos]="archivos"
      [tipoTransporte]="tipoTransporte"
      [tipoUnidad]="tipoUnidad"
      [locations]="locations"
      [listTransportLine]="listTransportLine"
      [transportList]="transportList"
      [originsTicket]="originsTicket"
      (onRegresar)="closeDetalle()"
      *ngIf="tipoEntrada === 1 && !loaderOverlay && !detail"
    ></app-cabotage-entry-transport>
    <app-cabotage-entry-adjustment
      [containerStyles]="containerStyles"
      [entriesType]="entriesType"
      [entryDetalle]="entryDetalle"
      [movimiento]="movimiento"
      [locations]="locations"
      (onRegresar)="closeDetalle()"
      *ngIf="tipoEntrada === 2 && !loaderOverlay && !detail"
    ></app-cabotage-entry-adjustment>
    <app-cabotaje-form-salida-traspaso-detail
      [entry]="entryDetalle[0]"
      (onRegresar)="closeDetalle()"
      *ngIf="!loaderOverlay && detail"
    ></app-cabotaje-form-salida-traspaso-detail>
    <app-loader class="loader" *ngIf="loaderOverlay"></app-loader>
  </div>
</div>
<app-overlay
  *ngIf="errorOverlay"
  [mensaje]="mensaje"
  icono="bi bi-exclamation-circle-fill"
></app-overlay>
<app-overlay
  *ngIf="loading"
></app-overlay>
<app-overlay
*ngIf="overlayError"
[reload]="true"
></app-overlay>
<app-overlay
  *ngIf="overlayCorrectDelete"
  mensaje="Entrada eliminada correctamente"
  icono="bi bi-check2"
></app-overlay>
<app-overlay
  icono="bi bi-info-circle-fill"
  mensaje="Sin autorización para esta acción."
  *ngIf="isAuthorized"
></app-overlay>
